import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import PrimaryButton from "../../../../Components/Buttons/PrimaryButton/PrimaryButton";
import { urls } from "../../../../Routes/Urls";
import classes from "../Banner.module.css";

const MobileHeader = () => {
    const history = useHistory();
    return(
        <div className={classes.ctaDiv}>
        <p className={classes.mainHeader}>
          Elevate your book collection with us
        </p>
        <PrimaryButton onClick={() => history.push(urls.LISTING)}>
          Explore Our Collection
        </PrimaryButton>
      </div>
    )
}

export default MobileHeader;